export default {
	email: {
		address: null,
		firstName: null,
		lastName: null,
		phoneNumber: null,
		validated: false,
		preauthToken: null
	},
	verification: {
		code: null,
		verified: false,
		validating: false,
		error: null
	},
	gift: {
		submitting: false,
		submitted: false,
		error: null
	},
	status: {
		busy: false,
		error: null,
		step: 'email' // 'email' | 'verify' | 'complete'
	},
	tracking: {
		source: null
	}
}
